import { downloadApk } from '../../../utils/downloadApk';

export function HeroSection() {
  return (
    <main className="hero-bg relative min-h-screen flex items-center justify-center overflow-hidden pt-16 md:pt-20">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-t from-darker via-darker/50 to-darker/20" />
        <div className="absolute inset-0 hero-gradient" />
      </div>

      <div className="hidden sm:block absolute top-1/4 left-4 md:left-10 animate-bounce opacity-20">
        <span className="material-icons text-4xl md:text-6xl text-primary">casino</span>
      </div>
      <div className="hidden sm:block absolute bottom-1/4 right-4 md:right-10 animate-pulse opacity-20">
        <span className="material-icons text-5xl md:text-7xl text-accent">stars</span>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 text-center py-16 md:py-24">
        <div className="inline-flex items-center space-x-2 bg-primary/10 backdrop-blur-sm px-3 sm:px-4 py-2 rounded-full border border-primary/20 mb-6 md:mb-8">
          <span className="flex h-2 w-2 rounded-full bg-accent animate-ping flex-shrink-0" />
          <span className="text-xs font-bold tracking-[0.15em] uppercase text-accent">
            Now Live: Exclusive High Stakes Baccarat
          </span>
        </div>

        <h1 className="font-serif text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-black mb-4 md:mb-6 tracking-tight leading-tight text-glow">
          Experience the
          <br />
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-primary to-accent">
            Golden 777
          </span>
        </h1>

        <p className="text-base sm:text-lg md:text-2xl text-slate-300 mb-8 md:mb-12 max-w-2xl mx-auto font-medium px-2">
          Indulge in the pinnacle of luxury gaming. Safe, secure, and thrilling experiences tailored for the world&apos;s most discerning players.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <button
            type="button"
            onClick={downloadApk}
            className="group w-full sm:w-auto px-10 sm:px-12 py-4 sm:py-5 bg-accent text-darker font-black text-base sm:text-lg rounded-full hover:bg-white transition-all transform hover:scale-105 active:scale-95 shadow-2xl shadow-accent/20"
          >
            <span className="flex items-center justify-center gap-2 uppercase tracking-tighter">
              <span className="material-icons text-xl">play_arrow</span>
              Play Now
            </span>
          </button>
          <button
            type="button"
            onClick={downloadApk}
            className="group w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-white/5 backdrop-blur-md border border-white/20 text-white font-bold text-base sm:text-lg rounded-full hover:bg-white/10 transition-all uppercase tracking-tighter"
          >
            <span className="flex items-center justify-center gap-2">
              <span className="material-icons text-xl">android</span>
              Download APK
            </span>
          </button>
        </div>

        <div className="mt-12 md:mt-24 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto">
          <div className="card-glass p-4 md:p-6 rounded-2xl flex flex-col items-center gap-1">
            <span className="material-icons text-accent text-2xl md:text-3xl">security</span>
            <span className="text-xs text-slate-400 uppercase tracking-widest font-bold text-center">Safe &amp; Secure</span>
          </div>
          <div className="card-glass p-4 md:p-6 rounded-2xl flex flex-col items-center gap-1">
            <span className="material-icons text-primary text-2xl md:text-3xl">speed</span>
            <span className="text-xs text-slate-400 uppercase tracking-widest font-bold text-center">Fast Payouts</span>
          </div>
          <div className="card-glass p-4 md:p-6 rounded-2xl flex flex-col items-center gap-1">
            <span className="material-icons text-accent text-2xl md:text-3xl">workspace_premium</span>
            <span className="text-xs text-slate-400 uppercase tracking-widest font-bold text-center">VIP Rewards</span>
          </div>
          <div className="card-glass p-4 md:p-6 rounded-2xl flex flex-col items-center gap-1">
            <span className="material-icons text-primary text-2xl md:text-3xl">headset_mic</span>
            <span className="text-xs text-slate-400 uppercase tracking-widest font-bold text-center">24/7 Support</span>
          </div>
        </div>
      </div>
    </main>
  );
}
